export default __webpack_public_path__ + "static/media/stamp.19da077a.svg";